import React, { createContext, useContext, useState } from 'react';
import propTypes from 'prop-types';

import UploadPensionModal from './modals/UploadPension';
import UploadPartnerPensionModal from './modals/UploadPartnerPension';

export const ModalEnums = {
    UPLOAD_PENSION: 'UPLOAD_PENSION',
    UPLOAD_PARTNER_PENSION: 'UPLOAD_PARTNER_PENSION',
};

const ModalMap = {
    [ModalEnums.UPLOAD_PENSION]: UploadPensionModal,
    [ModalEnums.UPLOAD_PARTNER_PENSION]: UploadPartnerPensionModal,
};

const ModalContext = createContext(null);
ModalContext.displayName = 'ModalContext';

export function ModalProvider({ children }) {
    const [modal, rawSetModal] = useState(false);
    const [modalProps, setModalProps] = useState(null);
    const setModal = (newModal, props) => {
        if (!ModalEnums[newModal]) throw new Error('Invalid modal enum');
        rawSetModal(newModal);
        setModalProps(props);
    };

    const closeModal = () => rawSetModal(null);

    const ModalComponent = ModalMap[modal];

    return (
        <ModalContext.Provider value={{ modal, setModal, closeModal }}>
            { children }
            { modal && <ModalComponent closeModal={ closeModal } { ...modalProps } /> }
        </ModalContext.Provider>
    );
}

ModalProvider.propTypes = {
    children: propTypes.node.isRequired,
};

export function useModal() {
    const context = useContext(ModalContext);
    if (!context) throw new Error('useModal must be used within ModalProvider');
    return context;
}
